module.exports = __webpack_public_path__ + "img/inline-with-white.11a1810a.svg";